// ===============================
// src/ListeGardeValideeResponsable.jsx
// ===============================
// Wrapper Responsable : retours responsable + accès modification
// ===============================

import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import ListeGardeValideeCore from "./ListeGardeValideeCore.jsx";
import { collapseResponsibleSelfBack, sanitizeResponsibleBack } from "./responsableBack.js";

/**
 * Retour depuis l'app Port-Royal vers un chemin interne responsable/superviseur/portail.
 * @param {string|null} raw
 * @returns {string}
 */
function sanitizeBack(raw) {
  return collapseResponsibleSelfBack(sanitizeResponsibleBack(raw));
}

export default function ListeGardeValideeResponsable() {
  const [searchParams] = useSearchParams();
  
  // ✅ Récupérer le type de garde depuis l'URL pour le retour correct
  const typeGarde = searchParams.get("type") || "PR2"; // PR2 par défaut pour compatibilité
  const backFromHub = searchParams.get("back");
  const lockSecteur = searchParams.get("lockSecteur") === "1";
  const withCurrentBack = (path) => {
    let next = path;
    if (lockSecteur && !/[?&]lockSecteur=/.test(next)) {
      const sep = next.includes("?") ? "&" : "?";
      next = `${next}${sep}lockSecteur=1`;
    }
    if (backFromHub && !/[?&]back=/.test(next)) {
      const sep = next.includes("?") ? "&" : "?";
      next = `${next}${sep}back=${encodeURIComponent(backFromHub)}`;
    }
    return next;
  };
  
  // ✅ Depuis le menu multisecteur, `back` pointe vers index.html?secteur=… ; sinon écran gardes PR
  const topBackPath = useMemo(() => {
    const fromQuery = sanitizeBack(backFromHub);
    if (fromQuery) return fromQuery;
    return withCurrentBack(`/responsable/gardes?type=${encodeURIComponent(typeGarde)}`);
  }, [backFromHub, typeGarde, lockSecteur]);

  const isTho = typeGarde === "ASTREINTE_THORACIQUE";

  return (
    <ListeGardeValideeCore
      variant="responsable"
      topBackPath={topBackPath}
      topBackLabel={isTho ? "← Retour à la gestion des astreintes" : "← Retour à la gestion des gardes"}
      typeGarde={typeGarde}
      // ✅ Titre/subtitle adaptés au type
      title={isTho ? "Liste d'astreintes validée" : "Liste de garde validée"}
      subtitle={isTho
        ? "Version validée de la liste d'astreintes thoraciques. Vous pouvez ajuster la liste si besoin."
        : "Version validée de la liste de garde. Vous pouvez ajuster la liste si besoin."
      }
    />
  );
}
